import React from 'react';
import { Truck, Package, CheckCircle } from 'lucide-react';

const CTASection = () => {
  return (
    <section id="shop" className="py-20 bg-[#2C2416] text-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        {/* Section Header */}
        <p className="text-[#C9A961] text-sm tracking-widest uppercase mb-4">
          Ready to Start?
        </p>
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Fuel your best day. <br />Every day.
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
          Join thousands who've made GUAG their daily foundation. Nutrition that holds. 
          Energy that lasts. No shortcuts.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-16">
          <a
            href="#shop"
            className="px-8 py-4 bg-[#8B6F47] text-white rounded-full hover:bg-[#C9A961] transition-colors font-medium text-lg"
          >
            Shop GUAG — From R59
          </a>
          <a
            href="#project"
            className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-full hover:bg-white hover:text-[#2C2416] transition-colors font-medium text-lg"
          >
            Learn About GUAG/PROJECT
          </a>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 pt-8 border-t border-gray-700">
          <div className="flex items-center gap-3">
            <Truck className="text-[#C9A961]" size={24} />
            <span className="text-gray-300">Free SA Shipping</span>
          </div>
          <div className="flex items-center gap-3">
            <Package className="text-[#C9A961]" size={24} />
            <span className="text-gray-300">Up to 25 Servings Per Pack</span>
          </div>
          <div className="flex items-center gap-3">
            <CheckCircle className="text-[#C9A961]" size={24} />
            <span className="text-gray-300">Satisfaction Guaranteed</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;